<template>
  <b-form-select :id="id" :value="value" :options="platformOptions" @change="$emit('input', $event)">
    <template #first>
      <option :value="null" v-translate>None</option>
    </template>
  </b-form-select>
</template>

<script>
// Select of 3P platforms for an ecosystem's `outsourcing_platform_id` (MOOV-5543), used through the engine's
// componentEdit. The backend finds the ecosystem of a platform with first(), so a platform already linked to
// another ecosystem is shown disabled: linking it twice would leave one of them unreachable.
export default {
  name: 'EcosystemPlatformSelect',
  props: {
    value: {
      type: Number,
      default: null
    },
    id: {
      type: String,
      default: 'ecosystem-platform-select'
    },
    // The ecosystem being edited, whose own link doesn't count as taken
    ecosystemId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      linkedEcosystems: []
    }
  },
  computed: {
    platformOptions() {
      return this.platforms3p.map(platform => {
        const owner = this.linkedEcosystems.find(
          x => x.outsourcing_platform_id === platform.id && x.id !== this.ecosystemId
        )
        return {
          value: platform.id,
          text: owner
            ? this.$gettextInterpolate(this.$gettext('%{platform} (linked to #%{id} %{name})'), {
                platform: platform.name,
                id: owner.id,
                name: owner.name
              })
            : platform.name,
          disabled: !!owner
        }
      })
    }
  },
  created() {
    this.fetchPlatforms3p()
    // GET /ecosystems paginates by default; the explicit limit brings them all
    this.$http
      .get(this.$appConfig.api.baseUrl + 'ecosystems', {
        params: { fields: 'id,name,outsourcing_platform_id', limit: 1000 }
      })
      .then(response => {
        this.linkedEcosystems = response.body.data.filter(x => x.outsourcing_platform_id)
      })
  }
}
</script>
